var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUspGlobe = function SvgUspGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 76 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 25,
    r: 22,
    fill: "#F4F3F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0986 60C22.6726 60 15.5507 57.05 10.2996 51.799C5.04862 46.548 2.09863 39.4261 2.09863 32C2.09863 24.5739 5.04862 17.452 10.2996 12.201C15.5507 6.94999 22.6726 4 30.0986 4V60Z",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0986 4C30.0986 4 16.0986 12 16.0986 32C16.0986 52 30.0986 60 30.0986 60",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0989 20H4.79492",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0989 44H4.79492",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6029 35.6613C44.6029 35.6613 49.7815 40.9547 54.8162 38.7627C65.0242 34.3147 59.6855 20.5573 61.9015 14.3387C58.1097 13.7945 54.243 14.1557 50.6176 15.3927C46.9922 16.6298 43.7111 18.7075 41.0429 21.456C36.6055 26.344 37.9415 31.6693 44.6029 35.6613Z",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9223 26.7786C49.9223 26.7786 41.4903 30.7786 42.3917 49.424",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgUspGlobe;